(function($, Drupal, ServiceBus, Topics) {
  if (!Topics.events || !Topics.events.FINDATION_BUTTON_CLICKED || $('.js-third-party-tout-findation-cta').length > 0) {
    return;
  }
  const isIframe = window.location !== window.parent.location;
  const globals = Drupal?.settings?.globals_variables || Drupal?.settings?.global_variables || {};

  const goTo = function (url) {
    trackEvent('widget_cta', 'Findation', 'Widget', 'Try Our Virtual Tool');
    window.location.href = url;
  };

  const triggerEvent = function (value) {
    const parts = value.split('||');
    const eventName = parts[0];
    const eventPayload = parts[1] || {};
    const eventLabel = (eventName === 'open_vto') ? 'Try Our Virtual Tool' : 'chat now';

    switch (eventName) {
      case 'open_vto':
        // falls through
      case 'live_chat': {
        const $elem = $(eventPayload);

        if ($elem.length > 0) {
        // Keep HTML elem .click(), doesn't work with jQuery.
          $elem[0].click();
        }
        break;
      }
      default:
        $(document).trigger(eventName, eventPayload);
    }

    trackEvent('widget_cta', 'Findation', 'Widget', eventLabel);
  };

  const changeSku = function (productCode) {
    const shadeGridContainerSelector = globals?.findationShadeGridSelector || 'data-sku-id';
    const $shadeGrid = $(shadeGridContainerSelector);
    const shadeGridAttrName = globals?.findationShadeGridAttrName || 'data-sku-id';
    const safeProductCode = String(productCode).replace(/"/g, '\\"');

    $shadeGrid.find(`[${shadeGridAttrName}="${safeProductCode}"]`).trigger('click');

    trackEvent('widget_cta', 'Findation', 'Widget', 'Shop Now');
  };

  const startOver = function () {
    trackEvent('widget_cta', 'Findation', 'Widget', 'Start Over');
  };

  const addMore = function () {
    trackEvent('widget_cta', 'Findation', 'Widget', 'Add Products');
  };

  var $iframeFindations = $();
  var loadingFindation = false;

  if (!window.Findation) {
    window.Findation = {};
  }

  function trackEvent(eName, eCategory, eAction, elabel) {
    const postMsg = {
      _elc_action: 'findationWidget',
      _elc_analytics_action_name: eName,
      _elc_analytics_action_label: elabel
    };

    if (isIframe) {
      window.parentIFrame?.sendMessage(postMsg, '*');
    } else {
      site.track.evtLink({
        event_name: eName,
        event_category: eCategory,
        event_action: eAction,
        event_label: elabel
      });
    }
  }

  $(document).on('findation-ready', function(e, data) {
    $(document).trigger('findation-initialised');

    if (data.showWidget) {
      showFindation(data.selector || '');
    } else if (window.Findation && window.Findation.iframe) {
      // When we preload, we need to set iframe here
      $iframeFindations = !$iframeFindations.length ? $(window.Findation.iframe) : $iframeFindations;
    }
  });

  $(document).on('findation-initialised', function () {
    Findation.onActionReceived = function (payload) {
      const parts = payload.split('::');
      const action = parts[0];
      const value = parts[1];

      switch (action) {
        case 'goTo':
          !isIframe && goTo(value);
          break;
        case 'event':
          !isIframe && triggerEvent(value);
          break;
        case 'changeSku':
          !isIframe && changeSku(value);
          break;
        case 'startOver':
          !isIframe && startOver();
          break;
        case 'addMore':
          !isIframe && addMore();
          break;
        default:
      }
    };
  });

  $(document).on('findation-preload', function(e, data) {
    if (!data?.findationKey || !data.selector || Findation.isShowingWidget) {
      return;
    }
    loadFindation(data.findationKey, data.selector, data.options || {}, false);
  });

  $(document).on('findation-load', function(e, data) {
    if (!data?.findationKey || !data.selector) {
      return;
    }
    $iframeFindations.length > 0 ? showFindation(data.selector) : loadFindation(data.findationKey, data.selector, data.options || {}, true);
  });

  function getFindationIframe() {
    return $(parent.document).find('#' + window.frameElement?.id);
  }

  function setFindationTakeoverStyles(positionSelector) {
    const $findationIframe = getFindationIframe();
    $findationIframe.addClass('iframe-page-takeover');
    $(positionSelector, window.document).addClass('invisible-elem');
    $('body', window.document).addClass('bg-transparent');
    $(parent.document.body).addClass('iframe-page-takeover overflow-y-hidden');
  }

  function resetFindationInitialStyles(positionSelector) {
    const $findationIframe = getFindationIframe();
    $findationIframe.removeClass('iframe-page-takeover');
    $(positionSelector).removeClass('invisible-elem');
    $('body', window.document).removeClass('bg-transparent');
    $(parent.document.body).removeClass('iframe-page-takeover overflow-y-hidden');
  }

  function showFindation(positionSelector) {
    Findation.widgetDidClose = function() {
      trackEvent('widget_closed', 'Findation', 'Widget', 'Closed');
      Findation.isShowingWidget = false;
      if (isIframe) {
        resetFindationInitialStyles(positionSelector);
      }
    };

    Findation.persistUser = function(userId) {
      localStorage.setItem("findation_user_id", userId);
    };

    Findation.onSearchComplete = function(data) {
      trackEvent('searchComplete', 'Findation', 'Widget', 'Shades Entered');
      if (data.matchSuccess) {
        trackEvent('recommendedShade', 'Findation', 'Widget', data.recommendedShade);
      } else {
        trackEvent('no_recommendation', 'Findation', 'Widget', 'Widget No Recommendation');
      }
    };

    if (Findation && Findation.iframe && !Findation.isShowingWidget) {
      $iframeFindations = !$iframeFindations.length ? $(Findation.iframe) : $iframeFindations;
      $iframeFindations.show();
      Findation.isShowingWidget = true;
      trackEvent('widget_opened', 'Findation', 'Widget', 'Opened');
      if (isIframe) {
        setFindationTakeoverStyles(positionSelector);
      }
    }
  }

  function loadFindation(findationKey, positionSelector, options, showWidget) {
    if (!$iframeFindations.length && !loadingFindation && !Findation.isShowingWidget) {
      loadingFindation = true;
      const widgetVersion = globals.findationWidgetVersion ?? '13';
      const enableCache = globals.findationGetScriptCache ?? true;
      $.ajaxSetup({ cache: enableCache, async: true });
      $.getScript('https://findation.com/javascripts/w-adv-' + widgetVersion + '.js', function() {
        Findation.widgetEmbedded = function() {
          trackEvent('widget_presented', 'Findation', 'Widget', 'Presented');
        }

        Findation.widgetDidOpen = function() {
          trackEvent('widget_opened', 'Findation', 'Widget', 'Opened');
          Findation.isShowingWidget = true;
        };

        Findation.widgetDidClose = function() {
          trackEvent('widget_closed', 'Findation', 'Widget', 'Closed');
          Findation.isShowingWidget = false;
          if (isIframe) {
            resetFindationInitialStyles(positionSelector);
          }
        };

        Findation.persistUser = function(userId) {
          localStorage.setItem("findation_user_id", userId);
        };

        Findation.onSearchComplete = function(data) {
          trackEvent('searchComplete', 'Findation', 'Widget', 'Shades Entered');
          if (data.matchSuccess) {
            trackEvent('recommendedShade', 'Findation', 'Widget', data.recommendedShade);
          } else {
            trackEvent('no_recommendation', 'Findation', 'Widget', 'Widget No Recommendation');
          }
        };

        Findation.onAddMoreShades = function() {
          trackEvent('widget_cta', 'Findation', 'Widget', 'AddMoreShades');
        };

        Findation.onStartOver = function() {
          trackEvent('widget_cta', 'Findation', 'Widget', 'StartOver');
        };

        Findation.onActionReceived = function (payload) {
          const parts = payload.split('::');
          const action = parts[0];
          const value = parts[1];

          switch (action) {
            case 'goTo':
              !isIframe && goTo(value);
              break;
            case 'event':
              !isIframe && triggerEvent(value);
              break;
            case 'changeSku':
              !isIframe && changeSku(value);
              break;
            case 'startOver':
              !isIframe && startOver();
              break;
            case 'addMore':
              !isIframe && addMore();
              break;
            default:
          }
        };

        Findation.init(
          $(positionSelector)[0],
          findationKey,
          options
        );

        const pageLocation = isIframe ? window.parent.location : window.location;
        const searchParams = new URLSearchParams(pageLocation.search);

        if (searchParams.get('open_findation') === '1' || searchParams.get('shadematch_open') === '1') {
          showWidget = true;
        }

        $(document).trigger('findation-ready', {selector: positionSelector, showWidget});
      }, enableCache).fail(function() {
        loadingFindation = false;
      });
    }
  }
  ServiceBus.on(Topics.events.FINDATION_BUTTON_CLICKED,
    function(payload) {
      if (payload) {
        if (ServiceBus.log) {
          ServiceBus.log({
            message: Topics.events.FINDATION_BUTTON_CLICKED,
            payload: { context: payload }
          });
        }

        if ($iframeFindations.length < 1) {
          var findationKey = payload.findationKey;
          const useFrFindationTranslation = globals?.useFrFindationTranslation;
          const findationFrApiKey = globals?.findationFrApiKey;

          const useTranslation = $.cookie('LOCALE') === 'fr_CA' ? 1 : 0;

          if (useTranslation && useFrFindationTranslation && findationFrApiKey) {
            findationKey = findationFrApiKey;
          }
          loadFindation(findationKey, '.js-third-party-tout-findation-cta', {}, true);
        } else {
          showFindation('');
        }
      }
    }
  );

  $(function () {
    const findationKey = globals?.findation?.apiKey;
    const selector = globals?.findation?.selector;
    const options = { productUrl: decodeURI(window.location.href) };

    if (findationKey) {
      $(document).trigger('findation-preload', {
        findationKey,
        selector,
        options
      });
    }
  });

})(
  jQuery,
  Drupal,
  window.GlobalServiceBus || {},
  window.ServiceBusTopics || {}
);
